import { c as _c } from "react/compiler-runtime";
import { stopLoggingBootErrors } from '@onefootprint/core';
import { Logger } from '@onefootprint/idv';
import type { AppProps } from 'next/app';
import Providers from '../components/providers';
import '../styles/globals.css';

// Don't enable logger replay until we know we are in a live onboarding
Logger.init('handoff', /* deferSessionRecord */true);
stopLoggingBootErrors();
const App = t0 => {
  const $ = _c(6);
  const {
    Component,
    pageProps
  } = t0;
  let t1;
  if ($[0] !== Component || $[1] !== pageProps) {
    t1 = <Component {...pageProps} />;
    $[0] = Component;
    $[1] = pageProps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== pageProps || $[4] !== t1) {
    t2 = <Providers pageProps={pageProps}>{t1}</Providers>;
    $[3] = pageProps;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default App;